// Loads the Google Identity Services script once and exposes helpers.
let scriptPromise = null;
let initializedClientId = null;
let credentialCallback = null;

const loadGoogleScript = () => {
    if (window.google?.accounts?.id) {
        return Promise.resolve();
    }
    if (!scriptPromise) {
        scriptPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://accounts.google.com/gsi/client';
            script.async = true;
            script.defer = true;
            script.onload = () => resolve();
            script.onerror = () => {
                scriptPromise = null;
                reject(new Error('Failed to load Google script'));
            };
            document.head.appendChild(script);
        });
    }
    return scriptPromise;
};

// GIS configuration is global to the page. React Strict Mode mounts effects
// twice in development, so initialize once and only replace the live callback.
const initializeGoogleIdentity = (clientId, callback) => {
    credentialCallback = callback;
    if (initializedClientId === clientId) return;
    window.google.accounts.id.initialize({
        client_id: clientId,
        callback: response => credentialCallback?.(response),
    });
    initializedClientId = clientId;
};

// Kept for callers that only need the configured client id.
const getGoogleClientId = async () => {
    const { getPublicConfig } = await import('./AuthService');
    try {
        const config = await getPublicConfig();
        return config?.googleClientId || null;
    } catch (err) {
        return null;
    }
};

export { loadGoogleScript, initializeGoogleIdentity, getGoogleClientId };
